import { render, staticRenderFns } from "./myChart.vue?vue&type=template&id=2b48bc25&scoped=true&"
import script from "./myChart.vue?vue&type=script&lang=js&"
export * from "./myChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b48bc25",
  null
  
)

export default component.exports